var StatusBadgeModule = /** @class */ (function () {
    function StatusBadgeModule() {
    }
    return StatusBadgeModule;
}());
export { StatusBadgeModule };
